import React from 'react'
// import AddFriendIcon from './user.png'
// import TrackReqImg from './time-tracking.png'
import SearchIcon from '../team_members_KM/search.png'
import {KTIcon} from '../../../../_metronic/helpers'
import CreateTemplateIcon from './templates.png'
import DragIcon from './drag.png'

function TemplatesKM() {
  return (
    <>
      <div className='row'>
        <div className='col-lg-4 p-0'>
          <div className='w-100 h-100 p-5'>
            <div className='shadow-sm p-3 rounded h-100 d-flex flex-column justify-content-center align-items-center'>
              <img src={CreateTemplateIcon} className='track-req-icon mb-5' alt='Add Friend' />
              <p className='text-center'>
                Click on the "+ Create" button to start creating a new template.
              </p>
            </div>
          </div>
        </div>
        <div className='col-lg-4 p-0'>
          <div className='w-100 h-100 p-5'>
            <div className='shadow-sm p-3 rounded h-100 d-flex flex-column justify-content-center align-items-center'>
              <img src={DragIcon} alt='Track Request' className='track-req-icon mb-5 mt-3' />

              <p>
                Customize the template layout by arranging elements intuitively using simple drag
                gestures.
              </p>
            </div>
          </div>
        </div>
        <div className='col-lg-4 p-0'>
          <div className='w-100 h-100 p-5'>
            <div className='shadow-sm p-3 rounded h-100 d-flex flex-column justify-content-center align-items-center'>
              <img src={SearchIcon} className='track-req-icon mb-5' alt='Add Friend' />
              <p className='text-center'>
                Use the search bar to easily find specific templates by their names or keywords.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default TemplatesKM
